module.exports = __webpack_public_path__ + "img/Ks.51960752.png";